<template>
    <div>
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>
        
        <div class="space-y-8">
            <section class="form-section">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'FATCA'" :TipoCliente="'Fundos'" :Sessao="'FATCA'" :SubSessao="'FATCA'"/>
                    <p class="text-sm text-gray-600 dark:text-gray-400 mt-1">Foreign Account Tax Compliance Act</p>
                </div>
                
                <div class="form-section-content">
                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label">É instituição Financeira Estrangeira (FFI) aderente ao FATCA?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="Facta_Nao"
                                        value="false"
                                        name="Facta"
                                        class="form-radio-input"
                                        v-model="localFI.Facta"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="Facta_Nao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="Facta_Sim"
                                        value="true"
                                        name="Facta"
                                        class="form-radio-input"
                                        v-model="localFI.Facta"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="Facta_Sim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="NumeroGiin">Se sim, informar o Nº GIIN:</label>
                            <input class="field" type="text" @change="salvarAlteracoesLocalmente" v-model="localFI.NumeroGiin" id="NumeroGiin">
                        </div>
                    </div>

                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label" for="NumeroGiinMotivos">Caso não o possua o Nº GIIN, informar os motivos:</label>
                            <textarea v-model="localFI.NumeroGiinMotivos" @change="salvarAlteracoesLocalmente" id="NumeroGiinMotivos" class="field h-20"></textarea>
                        </div>
                    </div>

                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label">Tem sede ou Filial nos EUA?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="SedeEua_Nao"
                                        value="false"
                                        name="SedeEua"
                                        class="form-radio-input"
                                        v-model="localFI.SedeEua"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="SedeEua_Nao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="SedeEua_Sim"
                                        value="true"
                                        name="SedeEua"
                                        class="form-radio-input"
                                        v-model="localFI.SedeEua"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="SedeEua_Sim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label">É Sociedade Constituída sob a Legislação dos EUA?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="SociedadeEua_Nao"
                                        value="false"
                                        name="SociedadeEua"
                                        class="form-radio-input"
                                        v-model="localFI.SociedadeEua"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="SociedadeEua_Nao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="SociedadeEua_Sim"
                                        value="true"
                                        name="SociedadeEua"
                                        class="form-radio-input"
                                        v-model="localFI.SociedadeEua"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="SociedadeEua_Sim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label">Possui vínculo societário com alguma instituição estrangeira?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="VinculoSocietarioEstrangeiro_Nao"
                                        value="false"
                                        name="VinculoSocietarioEstrangeiro"
                                        class="form-radio-input"
                                        v-model="localFI.VinculoSocietarioEstrangeiro"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="VinculoSocietarioEstrangeiro_Nao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="VinculoSocietarioEstrangeiro_Sim"
                                        value="true"
                                        name="VinculoSocietarioEstrangeiro"
                                        class="form-radio-input"
                                        v-model="localFI.VinculoSocietarioEstrangeiro"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="VinculoSocietarioEstrangeiro_Sim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="VinculoSocietarioEstrangeiroEspecificacao">Se sim, quais país(es)?</label>
                            <textarea v-model="localFI.VinculoSocietarioEstrangeiroEspecificacao" @change="salvarAlteracoesLocalmente" id="VinculoSocietarioEstrangeiroEspecificacao" class="field h-20"></textarea>
                        </div>
                    </div>

                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label">Possui alguma fonte de renda em Mercado Estrangeiro?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="FonteRendaMercadoEstrangeiro_Nao"
                                        value="false"
                                        name="FonteRendaMercadoEstrangeiro"
                                        class="form-radio-input"
                                        v-model="localFI.FonteRendaMercadoEstrangeiro"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="FonteRendaMercadoEstrangeiro_Nao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="FonteRendaMercadoEstrangeiro_Sim"
                                        value="true"
                                        name="FonteRendaMercadoEstrangeiro"
                                        class="form-radio-input"
                                        v-model="localFI.FonteRendaMercadoEstrangeiro"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="FonteRendaMercadoEstrangeiro_Sim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="FonteRendaMercadoEstrangeiroEspecificacao">Se sim, quais país(es)?</label>
                            <textarea v-model="localFI.FonteRendaMercadoEstrangeiroEspecificacao" @change="salvarAlteracoesLocalmente" id="FonteRendaMercadoEstrangeiroEspecificacao" class="field h-20"></textarea>
                        </div>
                    </div>

                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label">Possui conta corrente com movimentação no exterior?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="ContaCorrenteExterior_Nao"
                                        value="false"
                                        name="ContaCorrenteExterior"
                                        class="form-radio-input"
                                        v-model="localFI.ContaCorrenteExterior"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="ContaCorrenteExterior_Nao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="ContaCorrenteExterior_Sim"
                                        value="true"
                                        name="ContaCorrenteExterior"
                                        class="form-radio-input"
                                        v-model="localFI.ContaCorrenteExterior"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="ContaCorrenteExterior_Sim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="ContaCorrenteExteriorEspecificacao">Se sim, quais país(es)?</label>
                            <textarea v-model="localFI.ContaCorrenteExteriorEspecificacao" @change="salvarAlteracoesLocalmente" id="ContaCorrenteExteriorEspecificacao" class="field h-20"></textarea>
                        </div>
                    </div>

                    <div class="form-grid-1">
                        <div class="form-field">
                            <label class="form-field-label">Possui, entre seus sócios/acionistas, cidadão americano (U.S Person)?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="SociosCidadaAmericano_Nao"
                                        value="false"
                                        name="SociosCidadaAmericano"
                                        class="form-radio-input"
                                        v-model="localFI.SociosCidadaAmericano"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="SociosCidadaAmericano_Nao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input
                                        type="radio"
                                        id="SociosCidadaAmericano_Sim"
                                        value="true"
                                        name="SociosCidadaAmericano"
                                        class="form-radio-input"
                                        v-model="localFI.SociosCidadaAmericano"
                                        @change="salvarAlteracoesLocalmente"
                                    />
                                    <label for="SociosCidadaAmericano_Sim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <RepresentanteFatca />
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RepresentanteFatca from './representante-fatca.vue';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue';
export default {
    name: 'CadastroOutros_FATCA',
      components: { RepresentanteFatca, LabelDisclaimer},
      props: ['informacoesDeclaracoes','Edicao'],
      computed: {
        ...mapGetters({
            user: 'auth/user'
        }),
    },
    data() {
      return {
        permitirAvancar: false,
        localFI: this.informacoesDeclaracoes,
        nomeEmpresa: ''
      }
    },
    mounted()
    {
      this.nomeEmpresa = process.env.VUE_APP_NOME_EMPRESA;
      this.validarFormulario();
    },
    methods: {
      // eslint-disable-next-line no-unused-vars
      validarFormulario(submit = false)  {
        this.permitirAvancar = true;
        return this.permitirAvancar;
      },
      proximaEtapa(){
        if(this.validarFormulario())
        {
          this.$store.commit('SET_ETAPA_CADASTRO', 8);
          this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
          this.salvarInformacoes();
        }
      },
      salvarInformacoes(){
        this.$store.commit('SET_FI_SALVAR_INFO', true);
      },
      salvarAlteracoesLocalmente(){
        this.$store.commit('SET_FI_SALVAR_INFO_DECLARACAO', this.localFI);
        this.validarFormulario();
      },

    }
}

</script>


<style lang="scss" scoped>
</style>